import config from "../../app.json";
import axios from "axios";

import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import "./Styles/home.scss";

import DashboardPlanInfo from "../../Components/DashboardPlanInfo";
import SelectPlan from "../../Components/SelectPlan";
import PaymentInfo from "../../Components/PaymentInfo";
import Receipts from "../../Components/Receipts";
import ChurchInfoAwsConnectionUpdate from "../../Components/ChurchInfoAwsConnectionUpdate";
function Account() {
  const [seats, setSeats] = useState(null);
  const [plan, setPlan] = useState(null);

  const fetchSeats = () => {
    axios
      .post(config.API + "/api/church/getSeats")
      .then((res) => {
        if (res.status === 200 && res.data) {
          setSeats(res.data);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  useEffect(() => {
    fetchSeats();
  }, [0]);

  const handleSetPlan = (value) => {
    setPlan(value);
  };

  return (
      <Row>
        <Col className="col-md-11 mb-5 upgrade-plan-page">
        <ChurchInfoAwsConnectionUpdate />
          <Row>
            <Col className="col-md-12">
              <h4 className="page-section-title">Upgrading my plan</h4>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col className="col-md-3">
              <DashboardPlanInfo {...seats} upgradePlan={true} />
            </Col>
            {seats && (
              <Col md={9}>
                <SelectPlan
                  upgradePlan={true}
                  currentPlan={seats.planName}
                  setPlanOutside={handleSetPlan}
                />
              </Col>
            )}
            {!seats && <Col md={9}>&nbsp;</Col>}
          </Row>
          <Row>
            <Col className="col-md-5">
              <PaymentInfo
                setupFee={plan?.setupFee}
                planDescription={plan?.name}
                planPrice={plan?.value}
                planId={plan?.id}
                totalPrice={plan?.chargePrice}
                upgradePlan={true}
              />
            </Col>
            <Col className="col-md-7">
              <Receipts />
            </Col>
          </Row>
        </Col>
      </Row>
  );
}

export default Account;
